import styled from 'styled-components'
import EmptyIllustration from 'assets/illustration-empty-table.svg'

import Text from 'components/Text'
import { DynamicContainer } from 'components'

interface Props {
  message?: string
  isDynamicHeight?: boolean
}

const EmptyMessage = ({ message }: Props) => (
  <Container>
    <Text variant="body2" color="gray5" mb={16}>
      {message ?? `There is no data available yet`}
    </Text>
    <EmptyIllustration />
  </Container>
)

const EmptyView = ({ isDynamicHeight, ...props }: Props) => {
  if (isDynamicHeight) {
    return (
      <DynamicContainer>
        <EmptyMessage {...props} />
      </DynamicContainer>
    )
  }
  return <EmptyMessage {...props} />
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  border: 1px dashed ${(p) => p.theme.colors.defaultBorder};
  padding: 1.5rem;
`

export default EmptyView
